import type { SnapshotData } from "@slime/contracts";
import type { GameContext } from "../engine/core/GameContext";
import type { PressureState } from "../mechanics/pressure/PressureState";
const hex = (n: number) => `#${n.toString(16).padStart(6, "0")}`;
/** A deliberately approximate view; engine objects never escape into the record queue. */
export function captureScene(
  context: GameContext,
  pressure?: PressureState,
): Omit<SnapshotData, "reason"> {
  const { level, state, slimes, drops, catalog } = context;
  const nodes: SnapshotData["nodes"] = [],
    entities: SnapshotData["entities"] = [];
  if (!level)
    return {
      scene: { width: 480, height: 640, background: "#172035" },
      nodes: [],
      entities: [],
      metadata: {},
    };
  const { width, height, leakLine } = level.world;
  nodes.push({
    id: "defence",
    kind: "rect",
    x: width / 2,
    y: leakLine,
    width,
    height: 2,
    fill: "#FF4F70",
  });
  entities.push({ id: "player", label: "水枪", properties: {} });
  nodes.push({
    id: "player-body",
    entityId: "player",
    kind: "rect",
    x: state.playerX,
    y: height - 35,
    width: 42,
    height: 24,
    fill: "#69F0A5",
    cornerRadius: 8,
  });
  for (let i = 0; i < slimes.capacity; i++)
    if (slimes.active[i]) {
      const def = catalog.slimes[slimes.definition[i]],
        id = String(slimes.recordingEntityId[i]);
      const pending = Boolean(pressure?.pending[i]);
      entities.push({
        id,
        label: def.id,
        type: "slime",
        properties: {
          radius: slimes.radius[i],
          volume: pressure?.volume[i] ?? 0,
          pending,
        },
      });
      nodes.push({
        id: `${id}-body`,
        entityId: id,
        kind: "circle",
        x: slimes.x[i],
        y: slimes.y[i],
        radius: slimes.radius[i],
        scaleX: slimes.scaleX[i],
        scaleY: slimes.scaleY[i],
        fill: hex(def.visualColor),
      });
      if (pending)
        nodes.push({
          id: `${id}-label`,
          entityId: id,
          kind: "text",
          x: slimes.x[i],
          y: slimes.y[i] - 8,
          text: "!",
          fontSize: 16,
          color: "#172035",
        });
    }
  for (let i = 0; i < drops.capacity; i++)
    if (drops.active[i])
      nodes.push({
        id: `drop-${drops.recordingEntityId[i]}`,
        kind: "circle",
        x: drops.x[i],
        y: drops.y[i],
        radius: 2,
        fill: "#ABEAFF",
      });
  nodes.push({
    id: "hud",
    kind: "text",
    x: 12,
    y: 12,
    text: `${level.name} · 漏网 ${state.leaked}`,
    fontSize: 15,
    color: "#FFFFFF",
    align: "left",
  });
  if (state.phase !== "playing")
    nodes.push({
      id: "phase",
      kind: "text",
      x: width / 2,
      y: height / 2,
      text:
        (
          {
            paused: "暂停",
            "game-over": "失败",
            "level-clear": "通关",
            complete: "全部完成",
          } as Record<string, string>
        )[state.phase] ?? state.phase,
      fontSize: 28,
      color: "#FFFFFF",
    });
  return {
    scene: { width, height, background: "#172035" },
    nodes,
    entities,
    metadata: { phase: state.phase },
  };
}
